import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { styled } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_QUERY } from '../../../reducers/commonReducer';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
    '& .MuiInputLabel-root': {
        color: '#666',
        fontSize: '16px',
        fontWeight: 500,
        '&.Mui-focused': {
            color: '#2979ff',
        },
        '&.MuiInputLabel-shrink': {
            backgroundColor: 'white',
            padding: '0 8px',
            fontSize: '14px',
        },
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: '24px',
        backgroundColor: 'white',
        boxShadow: '0 0 0 1px #e0e0e0',
        '& fieldset': {
            borderColor: '#e0e0e0',
            borderRadius: '24px',
        },
        '&:hover fieldset': {
            borderColor: '#b0b0b0',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#2979ff',
            borderWidth: '2px',
        },
    },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
    padding: '6px 12px',
    fontStyle: 'italic',
    fontWeight: 500,
    fontSize: '16px',
    minWidth: '160px',
    width: '200px',
    '& .MuiSelect-icon': {
        color: '#2979ff',
    },
}));

export default function SortByDropdown({ user, getQualifiedLeads }) {
    const dispatch = useDispatch();
    const { query: { sort, page, limit } } = useSelector((state) => state.common);

    const handleChange = async (event) => {
        dispatch(UPDATE_QUERY({ sort: event.target.value }));
        await getQualifiedLeads(user?.['companyId']?.['_id'], `sortBy=${event.target.value}&page=${page}&limit=${limit}`);
    };

    return (
        <StyledFormControl variant="outlined">
            <InputLabel id="sort-by-label">Sort by</InputLabel>
            <StyledSelect
                labelId="sort-by-label"
                value={sort || ''}
                onChange={handleChange}
                label="Sort by"
                MenuProps={{
                    PaperProps: {
                        style: {
                            borderRadius: 16
                        },
                    },
                }}
            >
                <MenuItem value="">None</MenuItem>
                <MenuItem value="date">Date</MenuItem>
                <MenuItem value="fitScore">Fit score</MenuItem>
                <MenuItem value="receivedDate">Received Date</MenuItem>
                <MenuItem value="responseDate">Response Date</MenuItem>
            </StyledSelect>
        </StyledFormControl>
    );
}
